import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const externalImportRoute: InvariantJiraRoute = {
	name: 'external-import',
	path: '/jira/settings/system/external-import',
};
